const regex = /Edge?\/(8[3-9]|9\d|\d{3,})\.\d+(\.\d+|)|Firefox\/([89]\d|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(8[3-9]|9\d|\d{3,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(14\.\d+|(1[5-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\//;
export default function isValidBrowser(userAgent) {
  return regex.test(userAgent);
};